import React from "react";
import "./Chips.css";

/* One global status chip so every page shows the same color for the
   same status word — icon + text always together, never color alone. */
const STATUS_MAP = {
  ALLOCATED: { family: "chip-success", icon: "fa-check", label: "Allocated" },
  RETURNED: { family: "chip-blue", icon: "fa-rotate-left", label: "Returned" },
  CANCELLED: { family: "chip-danger", icon: "fa-ban", label: "Cancelled" },
  PENDING: { family: "chip-warning", icon: "fa-clock", label: "Pending" },
  COMPLETED: { family: "chip-success", icon: "fa-check", label: "Completed" },
  MISSED: { family: "chip-danger", icon: "fa-triangle-exclamation", label: "Missed" },
  COMPLETE: { family: "chip-success", icon: "fa-check", label: "Complete" },
  PARTIAL: { family: "chip-warning", icon: "fa-triangle-exclamation", label: "Partial" },
  "IN PROGRESS": { family: "chip-blue", icon: "fa-spinner", label: "In Progress" },
  IN_PROGRESS: { family: "chip-blue", icon: "fa-spinner", label: "In Progress" },
  // Form submission / review workflow statuses (Form Submission View page
  // and friends) -- same shared families, never a page-own color.
  DRAFT: { family: "chip-neutral", icon: "fa-pen", label: "Draft" },
  SUBMITTED: { family: "chip-success", icon: "fa-paper-plane", label: "Submitted" },
  APPROVED: { family: "chip-success", icon: "fa-check", label: "Approved" },
  REJECTED: { family: "chip-danger", icon: "fa-xmark", label: "Rejected" },
  OVERDUE: { family: "chip-danger", icon: "fa-triangle-exclamation", label: "Overdue" },
  READ_ONLY: { family: "chip-neutral", icon: "fa-lock", label: "Read Only" },
};

export default function StatusChip({ status }) {
  const key = String(status || "").trim().toUpperCase();
  const config = STATUS_MAP[key] || {
    family: "chip-neutral",
    icon: "fa-circle-question",
    label: status || "-",
  };

  return (
    <span className={`chip ${config.family}`}>
      <i className={`fa-solid ${config.icon}`} aria-hidden="true"></i>
      {config.label}
    </span>
  );
}
